import { Get } from "@/ai_studio/http/http.js";

const DataResolver = async (to, from, next) => {
  let at = await Get("listdata");
  to.meta["data_names"] = at;
  next();
};
export default DataResolver;
